module.exports = __webpack_public_path__ + "static/media/galerija_2022_0035.cbf0499d.jpg";